export class Fonts {
  public static readonly FONT_FAMILY = `"Avenir", "Helvetica Neue", "Helvetica", "Arial", sans-serif`;
  public static readonly FONT_SIZE = "32px";
  public static readonly FONT_WEIGHT = "400";

  public static readonly FONT_SIZE_SMALL = "24px";
}



// WEBPACK FOOTER //
// ./app/styling/fonts.ts